module.exports = __webpack_public_path__ + "static/marid-a809ee0fd0c80751dbf8056bbec7f5ff.jpeg";